import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const NearMissFilters = ({ filters, sites, onFilterChange, onClearFilters }) => {
  const { t } = useLanguage();
  const hasActiveFilters =
    filters?.site_id || filters?.risk_level !== 'All' || filters?.status !== 'All' || filters?.search;

  return (
    <div className="flex flex-col sm:flex-row gap-3 mb-5">
      {/* Search */}
      <div className="relative flex-1">
        <Icon name="Search" size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          placeholder={t('nearMissSearchPlaceholder')}
          value={filters?.search || ''}
          onChange={e => onFilterChange?.('search', e?.target?.value)}
          className="w-full pl-9 pr-3 py-2 rounded-lg border border-border bg-background text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-accent/50"
        />
      </div>

      {/* Site filter */}
      <select
        value={filters?.site_id || ''}
        onChange={e => onFilterChange?.('site_id', e?.target?.value)}
        className="px-3 py-2 rounded-lg border border-border bg-background text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-accent/50 min-w-[140px]"
      >
        <option value="">{t('nearMissAllSites')}</option>
        {sites?.map(site => (
          <option key={site?.id} value={site?.id}>{site?.site_name}</option>
        ))}
      </select>

      {/* Risk Level filter */}
      <select
        value={filters?.risk_level || 'All'}
        onChange={e => onFilterChange?.('risk_level', e?.target?.value)}
        className="px-3 py-2 rounded-lg border border-border bg-background text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-accent/50 min-w-[130px]"
      >
        <option value="All">{t('nearMissAllRiskLevels')}</option>
        <option value="High">{t('nearMissRiskHigh')}</option>
        <option value="Medium">{t('nearMissRiskMedium')}</option>
        <option value="Low">{t('nearMissRiskLow')}</option>
      </select>

      {/* Status filter */}
      <select
        value={filters?.status || 'All'}
        onChange={e => onFilterChange?.('status', e?.target?.value)}
        className="px-3 py-2 rounded-lg border border-border bg-background text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-accent/50 min-w-[130px]"
      >
        <option value="All">{t('nearMissAllStatuses')}</option>
        <option value="Open">{t('nearMissStatusOpen')}</option>
        <option value="Under review">{t('nearMissStatusUnderReview')}</option>
        <option value="Closed">{t('nearMissStatusClosed')}</option>
      </select>

      {/* Clear filters */}
      {hasActiveFilters && (
        <button
          onClick={onClearFilters}
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg border border-border text-sm text-muted-foreground hover:text-foreground hover:bg-muted transition-colors whitespace-nowrap"
        >
          <Icon name="X" size={14} />
          {t('clearFilters')}
        </button>
      )}
    </div>
  );
};

export default NearMissFilters;
